import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@api";
import { Helmet } from "react-helmet-async";
function ResetPassword() {
 const [searchParams] = useSearchParams();
 const navigate = useNavigate();
 const token = searchParams.get("token");

 const [password, setPassword] = useState("");
 const [confirmPassword, setConfirmPassword] = useState("");
 const [message, setMessage] = useState("");
 const [loading, setLoading] = useState(false);

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
   setLoading(true);
   if (password !== confirmPassword) {
    setMessage("Passwords do not match.");
    return;
   }
   const res = await api.post("/api/auth/reset-password", {
    token,
    newPassword: password,
   });

   setMessage(res.data.message);

   setTimeout(() => {
    navigate("/login");
   }, 2000);

  } catch (error) {
   setMessage(error.response?.data?.message || "Something went wrong.");
  } finally {
   setLoading(false);
  }
 };

 if (!token) {
  return <p>Invalid reset link.</p>;
 }

 return (
  <div style={{
   minHeight: "100vh",
   display: "flex",
   justifyContent: "center",
   alignItems: "center",
   background: "#f5f7fa"
  }}>
   <Helmet>
    <title>Reset Password | SportingHip</title>
    <meta name="robots" content="noindex,nofollow" />
   </Helmet>
   <div style={{
    background: "white",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "420px"
   }}>
    <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
     Reset Password
    </h2>

    {!token ? (
     <p style={{ textAlign: "center", color: "#dc2626" }}>
      Invalid or expired reset link.
     </p>
    ) : (
     <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <input
       type="password"
       placeholder="New password"
       value={password}
       onChange={(e) => setPassword(e.target.value)}
       required
       style={{
        padding: "0.75rem",
        borderRadius: "8px",
        border: "1px solid #ddd"
       }}
      />

      <input
       type="password"
       placeholder="Confirm password"
       value={confirmPassword}
       onChange={(e) => setConfirmPassword(e.target.value)}
       required
       style={{
        padding: "0.75rem",
        borderRadius: "8px",
        border: "1px solid #ddd"
       }}
      />

      <button
       type="submit"
       disabled={loading}
       style={{
        padding: "0.75rem",
        borderRadius: "8px",
        border: "none",
        background: "#111",
        color: "white",
        cursor: "pointer"
       }}
      >
       {loading ? "Resetting..." : "Reset Password"}
      </button>
     </form>
    )}

    {message && (
     <p style={{
      marginTop: "1rem",
      textAlign: "center",
      color: message.includes("successful") ? "#16a34a" : "#dc2626"
     }}>
      {message}
     </p>
    )}
   </div>
  </div>
 );
}

export default ResetPassword;